import { render, staticRenderFns } from "./ViewNewsItemPage.vue?vue&type=template&id=4e9f97d5&scoped=true&"
import script from "./ViewNewsItemPage.vue?vue&type=script&lang=js&"
export * from "./ViewNewsItemPage.vue?vue&type=script&lang=js&"
import style0 from "./ViewNewsItemPage.vue?vue&type=style&index=0&id=4e9f97d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9f97d5",
  null
  
)

export default component.exports